import Validators from '../validators'

export default (store) => store.createEmbededEntityState({
  attrs: [
    'id'
  ],
  titles: [
    store.__('tester')
  ],
  _sortField: 'id',
  validators: {
    '_global': (vals, items) => {
      if (!vals || vals.size <= 0) {
   //    return store.__('Select at least one "tester" or "group".')
      }
    }
  }
})
